import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'aggregation' })
export class AggregationPipe implements PipeTransform {
  transform<T>(elements: Array<T>, keyExtractor: (element: T) => string, pointcut: number = 3): string {
    const countSuffix: string = elements.length <= pointcut ? '' : ' (+' + (elements.length - pointcut) + ')';
    const str = elements
      .slice(0, elements.length <= pointcut ? elements.length : pointcut)
      .map((element: T) => keyExtractor(element))
      .join(', ');

    return str + countSuffix;
  }
}
